// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"f406141996641288","558":"4731a86cada32faa","777":"09b16783582f8f6e"}[chunkId] + ".js";
};